import { stringHelper } from './string-helper.class.js';

export class NameHelper {
	getUserName(email?: string, firstName?: string, lastName?: string): string {
		if (!firstName && !lastName) {
			if (email) {
				return stringHelper.getEmailUsername(email);
			}
			return '(deleted)';
		}

		let name: string = '';

		if (firstName) {
			name = firstName;
		}

		if (firstName && lastName) {
			name = `${firstName.trim()} ${lastName.trim()}`;
		}

		return name.trim();
	}
}

export const nameHelper = new NameHelper();
